import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import { mvtTypeData } from "../../../data";

const { TextArea } = Input;

const AddLedgerItemModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bank, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);
  const { folderObj } = useSelector((state) => state.folder);
  const [formData, setFormData] = useState(prodd);

  const onFinish = async (data) => {
    data.ilId = prodd ? prodd?.ilId : null;
    data.ilItemId = folderObj?.stId;
    data.ilTotalCost =
      data?.ilMovementType === "NEGATIVE"
        ? -data?.ilTotalCost
        : data.ilTotalCost;
    data.ilQuantity =
      data?.ilMovementType === "NEGATIVE" ? -data.ilQuantity : data.ilQuantity;
    const res = await dispatch(
      save({
        ...data,
        url: "asset/saveItemLedger.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    const { ilQuantity = 0, ilUnitCost = 0 } = allValues;
    const totalCost = ilQuantity * ilUnitCost;

    form.setFieldsValue({
      ilTotalCost: totalCost,
    });
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue(prodd);
    } else {
      form.resetFields();
    }
  }, [prodd]);

  useEffect(() => {
    if (folderObj?.stUnitCost) {
      form.setFieldsValue({
        ilUnitCost: folderObj?.stUnitCost,
      });
    }
  }, [folderObj?.stUnitCost, form, prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit ledger item ${prodd?.ilMovementType}`
            : "Add ledger item details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          onValuesChange={handleValuesChange}
        >
          <Form.Item
            name="ilMovementType"
            className=""
            label={<span>Movement type</span>}
            rules={[
              {
                required: true,
                message: "Please select movement type",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                mvtTypeData?.length > 0 &&
                mvtTypeData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>
          <Form.Item
            className="table-form-item"
            name="ilQuantity"
            label="Quantity"
            rules={[
              {
                required: true,
                message: "Please add quantity",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            className="table-form-item"
            name="ilUnitCost"
            label="Unit cost"
            rules={[
              {
                required: true,
                message: "Please add unit cost",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            className="table-form-item"
            name="ilTotalCost"
            label="Total cost"
            rules={[
              {
                required: true,
                message: "Please add total cost",
              },
            ]}
          >
            <InputNumber
              disabled={true}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddLedgerItemModal;
